













































import {Component, Prop} from 'vue-property-decorator';
import Form, { Send } from '@/components/form-base';
import { DialogForm, FormOverlay} from '@/components/bwaff';
import subscriptionApi, { SubscriptionApi } from '@/views/settings/subscription/api';

@Component({
  components: {
    FormOverlay,
    DialogForm,
  }
})
export default class ApplyPromo extends Form {
  @Prop({ default: {} })
  data: any;

  getError(input: string):  any[] {
    let errors = this.pGetError(input);

    return errors
      ? errors.map((error: any) => this.t(error))
      : [];
  }


  promoCode: string = '';

  form: object = {};

  api: SubscriptionApi = subscriptionApi;

  close() {
    this.$emit('close');
  }

  @Send()
  submit() {
    if (this.promoCode.length > 0){
      return this.api.putPromoCode({promoCode: this.promoCode}).then(() => {
        this.close();
        this.bus.emit('toast-success', this.t('Promo code successfully applied.'));
      });
    }
  }
}
